<template>
  <div class="page-container">
    <div class="page-title">
      {{ $t('data.refund_transaction') }}
    </div>
    <RefundTransDetails />
  </div>
</template>

<script>
export default {
  name: 'Data_Payin',
  components: {
    RefundTransDetails: () => import('./components/RefundTransDetails.vue')
  }
}
</script>

<style scoped>
.page-container{
  margin: 40px 57px 50px 32px;
}
.page-container .page-title{
  padding-bottom: 24px;
  border-bottom: 1px solid #D3D7DF;
}
</style>
